<mat-label class="subHeading">Vehicle Segment</mat-label>
<mat-select [formControlName]="controlName" placeholder="Select Vehicle Segment" multiple>
    <ng-container *ngFor="let segment of segments">
        <mat-option [value]="segment">{{segment}}</mat-option>
    </ng-container>
</mat-select>